/**
 * Batch Report — mock data lấy từ spec §9 (PO `PRO-TLBL-25097`).
 *
 * Tạm thời FE render mock này trong khi backend chưa expose API
 * `/factory/<code>/batch-report?po=...`. Mode mặc định = `chua qui chuan`
 * (giống sample Excel: `CC = MC`, `CD = 0`).
 *
 * Lưu ý: keys camelCase trùng với column meta trong `batchReportColumns.ts`.
 * `_xlsx_row` lưu lại row Excel gốc để debug, không hiển thị.
 */
import type { BatchRow } from './batchReportColumns'

export const SAMPLE_PO_NO = 'PRO-TLBL-25097'
export const SAMPLE_INPUT_VALUE = 3630

/* ---------- INPUT (Excel rows 6–10) --------------------------------------- */

export const SAMPLE_INPUT_ROWS: BatchRow[] = [
  {
    _xlsx_row: 6,
    stackId: 'BL-R-25052',
    dateToWhz: '2026-03-09',
    dateToProcessing: '2026-03-11',
    item: 'RFAQ',
    noOfBag: 1000,
    mt: 82.163,
    mc: 13.04,
    blacks: 1.95,
    brokens: 2.71,
    blackBroken: 4.66,
    fm: 1.34,
    s20: 13.04,
    s19: 23.37,
    s18: 41.81873130070208,
    s16: 79.31,
    deducted: 0.27954225040136294,
    category: 'FAQ',
    pctValue: 0.9573338211266141,
    value: 3617.6496918447847,
    bagType: 'PP/JB',
    origin: '3rd Party',
    stackOrPallet: 'Pallet',
    mcStandard: 13.04,
    btgToStandardMc: 0,
  },
  {
    _xlsx_row: 7,
    stackId: 'BL-R-25052',
    dateToWhz: '2026-03-09',
    dateToProcessing: '2026-03-10',
    item: 'RFAQ',
    noOfBag: 855,
    mt: 80,
    mc: 13.04,
    blacks: 1.95,
    brokens: 2.71,
    blackBroken: 4.66,
    fm: 1.34,
    s20: 13.04,
    s19: 23.37,
    s18: 41.81873130070208,
    s16: 79.31,
    deducted: 0.2721830998394523,
    category: 'FAQ',
    pctValue: 0.9573338211266141,
    value: 3617.6496918447847,
    bagType: 'PP/JB',
    origin: '3rd Party',
    stackOrPallet: 'Pallet',
    mcStandard: 13.04,
    btgToStandardMc: 0,
  },
  {
    _xlsx_row: 8,
    stackId: 'BL-R-25052',
    dateToWhz: '2026-03-09',
    dateToProcessing: '2026-03-09',
    item: 'RFAQ',
    noOfBag: 1410,
    mt: 120,
    mc: 13.04,
    blacks: 1.95,
    brokens: 2.71,
    blackBroken: 4.66,
    fm: 1.34,
    s20: 13.04,
    s19: 23.37,
    s18: 41.81873130070208,
    s16: 79.31,
    deducted: 0.4082746497592069,
    category: 'FAQ',
    pctValue: 0.9573338211266141,
    value: 3617.649691844784,
    bagType: 'PP/JB',
    origin: '3rd Party',
    stackOrPallet: 'Pallet',
    mcStandard: 13.04,
    btgToStandardMc: 0,
  },
]

/* ---------- OUTPUT (Excel rows 105–107) ----------------------------------- */

export const SAMPLE_OUTPUT_ROWS: BatchRow[] = [
  {
    _xlsx_row: 105,
    stackId: 'BL-P-25097-47',
    dateToWhz: '2026-03-17',
    area: 'BL.A.B5',
    item: 'R-DSR',
    noOfBag: 1,
    mt: 0.095,
    mc: 12.89,
    blacks: 0.4,
    brokens: 0.8,
    blackBroken: 1.2000000000000002,
    fm: 95,
    s20: 0,
    s19: 0,
    s18: 0,
    s16: 0,
    deducted: 0,
    category: 'Rejects',
    pctValue: 0.0381999999999999,
    value: 145.5992999999996,
    bagType: 'Big bag',
    mcStandard: 12.89,
    btgToStandardMc: 0,
    qtyBeforeStd: 0.095,
    qtyAdjust: 0,
    qtyAfterStd: 0.095,
  },
  {
    _xlsx_row: 106,
    stackId: 'BL-P-25097-46',
    dateToWhz: '2026-03-17',
    area: 'BL.A.A4',
    item: 'R13-GTR A',
    noOfBag: 3,
    mt: 0,
    mc: 12.43,
    blacks: 0.8,
    brokens: 16,
    blackBroken: 16.8,
    fm: 0.2,
    s20: 0,
    s19: 0,
    s18: 0,
    s16: 17.46,
    deducted: 0,
    category: 'By-products',
    pctValue: 0.85054023145,
    value: 3241.8340921716754,
    bagType: 'Big bag',
    mcStandard: 12.43,
    btgToStandardMc: 0,
    qtyBeforeStd: 4.242,
    qtyAdjust: -4.242,
    qtyAfterStd: 0,
  },
  {
    _xlsx_row: 107,
    stackId: 'BL-P-25097-44',
    dateToWhz: '2026-03-17',
    area: 'BL.A.E4',
    item: 'R13-GTR A',
    noOfBag: 10,
    mt: 11.501,
    mc: 12.2,
    blacks: 12,
    brokens: 45.9,
    blackBroken: 57.9,
    fm: 4.89,
    s20: 0,
    s19: 0,
    s18: 0,
    s16: 23.69,
    deducted: 0,
    category: 'By-products',
    pctValue: 0.5644378135,
    value: 2151.35472615525,
    bagType: 'Big bag',
    mcStandard: 12.2,
    btgToStandardMc: 0,
    qtyBeforeStd: 11.501,
    qtyAdjust: 0,
    qtyAfterStd: 11.501,
  },
]
